module.exports = __webpack_public_path__ + "media/slider/WelcomeToComposzSubscriptionUS-4e776832.jpg";